<template>
  <div id="Login">
    <div class="handle">
      <component @toogle="toogle" :is="componentName"></component>
    </div>
  </div>
</template>

<script>
import login from "@/components/login/login.vue";
import findPassword from "@/components/login/findPassword.vue";
export default {
  data() {
    return {
      componentName: "login",
    };
  },
  components: {
    login,
    findPassword,
  },
  created() {},
  mounted() {},
  methods: {
    toogle(name) {
      this.componentName=name
    },
  },
};
</script>

<style lang="less" scoped>
#Login{
    height: 100%;
    position: relative;
    background-color: #ccc;
}
.handle{
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    padding: 15px;
    transform: translate(-50%,-50%);
    border-radius: 6px;
    overflow: hidden;
}
</style>